/* ==========================================================================
   Homara Deco - retoques de confianza fuera de las secciones.

   1) Tira de garantias en el panel de compra del producto.
   2) Misma tira debajo de todo boton de checkout (cajon lateral y /cart).
   3) "Pagar" pasa a "Finalizar compra".
   4) Textos guardados en los ajustes que ningun cambio de codigo pisa:
      el candado y la cinta del combo destacado.

   Vive aparte de hd.js a proposito: si algo de aca falla, no se lleva puesto
   el selector de combos ni la galeria, que son lo que realmente vende.
   ========================================================================== */
(function () {
  var ETIQUETA_CHECKOUT = 'Finalizar compra';

  var TEXTOS = [
    ['Pago seguro y encriptado', 'Pago protegido con Mercado Pago'],
    ['Más elegida', 'La más llevada']
  ];

  var ITEMS = [
    ['envio', 'Envío gratis a todo el país'],
    ['garantia', 'Garantía de 30 días'],
    ['pago', 'Pago protegido con Mercado Pago'],
    ['whatsapp', 'Te escribimos con el seguimiento']
  ];

  var ICONOS = {
    envio: '<path d="M3 7.5h10.5v8.5H3z"/><path d="M13.5 10.5H17l3.5 3.5V16h-7z"/><circle cx="7" cy="18" r="1.9"/><circle cx="16.5" cy="18" r="1.9"/>',
    garantia: '<path d="M12 3 4.8 5.9v5.6c0 4 3 7.5 7.2 8.6 4.2-1.1 7.2-4.6 7.2-8.6V5.9z"/><path d="m9.2 11.8 2 2 3.6-3.9"/>',
    pago: '<rect x="4" y="10.5" width="16" height="10.5" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>',
    whatsapp: '<path d="M20.5 11.6a8.4 8.4 0 0 1-12.2 7.4L3.6 20.4l1.4-4.8A8.4 8.4 0 1 1 20.5 11.6z"/>'
  };

  function svg(clave) {
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round">' +
      (ICONOS[clave] || ICONOS.garantia) +
      '</svg>'
    );
  }

  function construir(compacta) {
    var ul = document.createElement('ul');
    ul.className = compacta ? 'hd-gar hd-gar--compacta' : 'hd-gar';

    ITEMS.forEach(function (par) {
      var li = document.createElement('li');
      li.className = 'hd-gar__item';
      li.innerHTML =
        '<span class="hd-gar__ico" aria-hidden="true">' +
        svg(par[0]) +
        '</span><span class="hd-gar__txt"></span>';
      li.querySelector('.hd-gar__txt').textContent = par[1];
      ul.appendChild(li);
    });

    return ul;
  }

  /* --- 1) panel de compra del producto ---------------------------------- */
  function initPanel(raiz) {
    var paneles = (raiz || document).querySelectorAll('.hd-oferta__panel');

    paneles.forEach(function (panel) {
      if (panel.querySelector('.hd-gar')) return;

      var ancla = panel.querySelector('.hd-oferta__pagos');
      var tira = construir(false);

      if (ancla && ancla.parentNode) {
        ancla.parentNode.insertBefore(tira, ancla.nextSibling);
        return;
      }

      var form = panel.querySelector('.hd-oferta__form');
      if (form && form.parentNode) {
        form.parentNode.insertBefore(tira, form.nextSibling);
      }
    });
  }

  /* --- 2) debajo de cualquier boton de checkout -------------------------- */
  function contenedorDe(boton) {
    var n = boton;
    for (var i = 0; i < 4 && n.parentElement; i++) {
      n = n.parentElement;
      if (n.tagName === 'FORM') return n;
    }
    return boton.parentElement;
  }

  function initCheckout(raiz) {
    var botones = (raiz || document).querySelectorAll('[name="checkout"]');

    botones.forEach(function (boton) {
      if (boton.closest('.cart-page__summary, .hd-carro-conf')) return;

      var cont = contenedorDe(boton);
      if (!cont || !cont.parentNode) return;
      if (cont.parentNode.querySelector('.hd-gar')) return;

      var caja = document.createElement('div');
      caja.className = 'hd-carro-conf hd-carro-conf--cajon';
      caja.innerHTML =
        '<p class="hd-carro-conf__seguro">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="4" y="10.5" width="16" height="10.5" rx="2"/>' +
        '<path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/></svg>' +
        '<span></span></p>';
      caja.querySelector('span').textContent = 'Pago protegido con Mercado Pago';
      caja.appendChild(construir(true));

      cont.parentNode.insertBefore(caja, cont.nextSibling);
    });
  }

  /* --- 3 y 4) reemplazos de texto ---------------------------------------- */
  function cambiarEn(elemento, viejo, nuevo) {
    var caminante = document.createTreeWalker(elemento, NodeFilter.SHOW_TEXT, null);
    var nodo;
    while ((nodo = caminante.nextNode())) {
      var limpio = (nodo.nodeValue || '').trim();
      if (!limpio) continue;
      if (limpio === nuevo) return true;
      if (limpio === viejo) {
        nodo.nodeValue = nodo.nodeValue.replace(viejo, nuevo);
        return true;
      }
    }
    return false;
  }

  function renombrarCheckout(raiz) {
    var botones = (raiz || document).querySelectorAll('[name="checkout"]');
    botones.forEach(function (boton) {
      var caminante = document.createTreeWalker(boton, NodeFilter.SHOW_TEXT, null);
      var nodo;
      while ((nodo = caminante.nextNode())) {
        var limpio = (nodo.nodeValue || '').trim();
        if (!limpio) continue;
        if (limpio === ETIQUETA_CHECKOUT) return;
        if (limpio.toLowerCase().indexOf('pagar') === 0) {
          nodo.nodeValue = nodo.nodeValue.replace(limpio, ETIQUETA_CHECKOUT);
          return;
        }
      }
    });
  }

  /* Los ajustes guardados de la seccion ganan sobre cualquier default del
     codigo, asi que estos dos textos se corrigen aca en vez de pedirle al
     usuario que los cambie a mano en el editor. */
  function corregirTextos(raiz) {
    var base = raiz || document;

    base.querySelectorAll('.hd-oferta__seguro').forEach(function (el) {
      cambiarEn(el, TEXTOS[0][0], TEXTOS[0][1]);
    });

    base.querySelectorAll('.hd-opcion__cinta').forEach(function (el) {
      cambiarEn(el, TEXTOS[1][0], TEXTOS[1][1]);
    });
  }

  /* --- arranque y re-dibujados ------------------------------------------ */
  function initTodo(raiz) {
    try {
      initPanel(raiz);
      initCheckout(raiz);
      renombrarCheckout(raiz);
      corregirTextos(raiz);
    } catch (e) {
      /* nunca dejamos que esto tumbe el resto de la pagina */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  } else {
    initTodo();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initTodo(e.target);
  });

  if ('MutationObserver' in window) {
    var pendiente;
    new MutationObserver(function () {
      window.clearTimeout(pendiente);
      pendiente = window.setTimeout(function () { initTodo(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
